<template>
  <div class="leo2-details">
    <div class="okzhuan-detail">
      <div class="okzhuan-news">
        <div class="okzhuan-news-title">
          资讯动态
        </div>
      </div>
    </div>
    <div class="okzhuan-news-detail" v-if="detail">
      <div class="title">
        <div class="back" @click="goPack()">
          <span class="b1"></span>
          <span>返回</span>
        </div>
        <div class="t1">{{detail.Title}}</div>
      </div>
      <div class="time">
        {{detail.Date}}
      </div>

      <div class="con">
        <div v-html="detail.Content"></div>
      </div>
    </div>
  </div>

</template>

<script>
import { storage } from "@/utils/storage.js";
export default {
  name: "detail",
  data() {
    return {
      detail: {}
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.loadData()
    }
  },
  methods: {
    goPack() {
      this.$router.push({ path: '/news' })
    },
    loadData() {
      var id = this.$route.params.id;
      var key = 'news:' + id;
      this.axios.newsDetail({
        Id: id,
        is_count: !storage.get(key) ? 1 : 0
      }).then(res => {
        storage.set(key, 1);
        if (res.data.code === 0) {
          if (res.data.data) {
            this.detail = res.data.data
            document.title = res.data.data.Title + '-游好赚';
            document.querySelector('meta[name="description"]').setAttribute('content', res.data.data.Discription);
            document.querySelector('meta[name="keywords"]').setAttribute('content', res.data.data.Keywords);
          } else {
            this.detail = {}
          }
        } else {
          this.detail = {}
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .leo2-details {
    overflow: hidden;
    /*margin-top: 80px;*/

    .okzhuan-detail {
      width: 100%;
      height: 390px;
      clear: both;
      background: url("../../assets/images/banner_news.png") no-repeat center top;

      .okzhuan-news-title {
        width: 1080px;
        height: 390px;
        line-height: 390px;
        margin: 0 auto;
        font-size: 40px;
        color: white;
        font-weight: bold;
      }
    }

    .okzhuan-news-detail {
      width: 1000px;
      height: auto;
      overflow: hidden;
      margin: 40px auto;
      padding: 40px;
      background:#ffffff;
      border-radius: 10px;
      box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px; //将颜色提到前面，且将h-shadow,v-shadow设为0px,实现四周阴影

      .title {
        position: relative;
        text-align: center;
        height: 40px;
        line-height: 40px;
        font-size: 24px;
        color: #333;

        .back {
          position: absolute;
          width: 108px;
          left: 0;
          top: 0;
          background: #F5F5F5;
          border-radius: 5px;
          font-size: 20px;
          cursor: pointer;
          display:flex;
          align-items: center;
          .b1{
            width: 18px;
            height: 18px;
            background: url("../../assets/images/btn_left.png") no-repeat center center;
            margin:0 10px;
          }
        }
      }

      .time {
        height: 24px;
        line-height: 24px;
        font-size: 16px;
        color: #999;
        text-align: center;
      }
    }

    .con {
      margin-top: 40px;
      border-top: 1px #999 dashed;
      padding-top: 30px;

      p {
        line-height: 22px;
        font-size: 14px;
        color: #666;
        margin-bottom: 10px;

        span {
          display: block;
          text-indent: 15px;
          line-height: 22px;
        }
      }

      img {
        display: block;
        vertical-align: middle;
        margin: 10px auto;
      }
      /deep/img{
        max-width: 100%;
      }
    }
  }

</style>
